var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavourite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.967%",
    y1: "-34.913%",
    x2: "108.399%",
    y2: "81.161%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E4FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5141FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-413 -1262)",
    fill: "url(#a)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.99 1334.979c-8.157 0-14.795-6.657-14.795-14.838 0-8.18 6.638-14.837 14.796-14.837 8.16 0 14.798 6.657 14.798 14.837s-6.639 14.838-14.798 14.838m0-33.683c-10.363 0-18.795 8.453-18.795 18.845 0 10.391 8.43 18.848 18.795 18.848 10.365 0 18.797-8.455 18.797-18.848 0-10.391-8.43-18.845-18.797-18.845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.635 1318.635h-4.14v-4.152c0-.828-.674-1.505-1.503-1.505-.827 0-1.501.677-1.501 1.505v4.152h-4.14c-.828 0-1.5.676-1.5 1.506s.672 1.506 1.5 1.506h4.14v4.151c0 .831.674 1.507 1.501 1.507.829 0 1.502-.676 1.502-1.507v-4.151h4.14a1.506 1.506 0 0 0 0-3.012M453.232 1277.654c3.813-7.331 9.836-11.535 16.528-11.535 1.873 0 3.698.332 5.42.99 7.042 2.69 12.78 10.834 9.727 22.962-.53 2.098-.924 2.772-2.308 5.288a2.041 2.041 0 0 0-.176 1.562c.154.527.5.964.979 1.228.96.53 2.34.026 2.865-.931 1.554-2.824 1.997-3.701 2.612-6.141 3.647-14.498-3.788-24.576-12.24-27.806a19.34 19.34 0 0 0-6.928-1.27c-7.145 0-13.758 3.873-18.296 10.67-4.542-6.797-11.156-10.67-18.3-10.67-2.389 0-4.718.427-6.925 1.269-8.452 3.23-15.888 13.31-12.238 27.805 2.465 9.792 11.896 20.207 21.72 30.005 2.495 2.49 4.955 4.594 7.132 6.459l1.215 1.042a2.045 2.045 0 0 0 2.89-.22c.736-.86.638-2.16-.22-2.899l-1.227-1.05c-2.115-1.81-4.512-3.863-6.9-6.245-8.955-8.932-18.41-19.255-20.637-28.096-3.053-12.13 2.684-20.273 9.725-22.961a15.113 15.113 0 0 1 5.418-.991c6.693 0 12.718 4.204 16.531 11.533a2.036 2.036 0 0 0 1.816 1.106 2.04 2.04 0 0 0 1.817-1.104"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.f265144f213b7dfe9580875bcc50aaa7.svg";
export { ForwardRef as ReactComponent };